<app-protocolo-envio
    [titulo]="titulo"
    [instrucoesEnvio]="instrucoesEnvio"
    [routerLinkPesquisaLote]="['/solicitacoes-honra/lote']"
    [tipoConteudoArquivo]="tipoConteudoArquivo"
    [janelaEnvioAtual]="janelaEnvioAtual"
    [textoBtnArquivoExemplo]="textoBtnArquivoExemplo"
    [tipoArquivoExemplo]="tipoArquivoExemplo"
>
</app-protocolo-envio>


